import "core-js/modules/es.error.cause.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * StackFrame entity. It contains information about parsed stack frame
 * with optional original source fileName, line, column and source if available.
 */
class StackFrame {
  constructor({
    rootDir,
    fileName,
    line,
    column,
    sourceFragment,
    functionName,
    orgFileName,
    orgLine,
    orgColumn,
    orgSourceFragment
  }) {
    _defineProperty(this, "rootDir", void 0);
    _defineProperty(this, "fileName", void 0);
    _defineProperty(this, "line", void 0);
    _defineProperty(this, "column", void 0);
    _defineProperty(this, "sourceFragment", void 0);
    _defineProperty(this, "functionName", void 0);
    _defineProperty(this, "orgFileName", void 0);
    _defineProperty(this, "orgLine", void 0);
    _defineProperty(this, "orgColumn", void 0);
    _defineProperty(this, "orgSourceFragment", void 0);
    this.rootDir = rootDir;
    this.fileName = fileName;
    this.line = line;
    this.column = column;
    this.sourceFragment = sourceFragment;
    this.functionName = functionName;
    this.orgFileName = orgFileName;
    this.orgLine = orgLine;
    this.orgColumn = orgColumn;
    this.orgSourceFragment = orgSourceFragment;
  }

  /**
   * Returns the name of stack frame function.
   *
   * @returns {string} Name of the function (anonymous) if unavailable.
   */
  getFunctionName() {
    return this.functionName || '(anonymous function)';
  }

  /**
   * Returns the file name at originalFileName path
   *
   * @returns {string} Name of the file (after last slash).
   */
  getPrettyFileName() {
    return this.orgFileName?.split('/').pop() ?? '(unable to parse filename)';
  }

  /**
   * Return original fileUri stripped of path prefixes.
   *
   * @returns {string|undefined}
   */
  getPrettyOriginalFileUri() {
    const strippedUri = this.orgFileName?.replace(/^(webpack:\/\/|webpack-internal:\/\/\/)/gi, '');
    const indexOfFirstSlash = strippedUri?.indexOf('/');

    // Print paths relative to app dir
    if (indexOfFirstSlash) {
      return `./${strippedUri?.substring(indexOfFirstSlash + 1)}`;
    }
    if (this.rootDir) {
      return strippedUri?.replace(this.rootDir, '.');
    }
    return strippedUri;
  }
}
export { StackFrame };